import { render } from "./TimeRangeCalcSettingsPanel.vue?vue&type=template&id=58958ce0&scoped=true"
import script from "./TimeRangeCalcSettingsPanel.vue?vue&type=script&lang=js"
export * from "./TimeRangeCalcSettingsPanel.vue?vue&type=script&lang=js"

import "./TimeRangeCalcSettingsPanel.vue?vue&type=style&index=0&id=58958ce0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58958ce0"]])

export default __exports__